import { fetchAuthSession } from 'aws-amplify/auth';

async function getCurrentToken() {
  try {
    const { idToken } = (await fetchAuthSession()).tokens ?? {};
    return idToken;
  } catch (err) {
    console.log(err);
    return null;
  }
}

export default getCurrentToken;
